function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 2a2 2 0 11-4 0 2 2 0 014 0zM4.5 8a2 2 0 11-4 0 2 2 0 014 0zM2.5 16a2 2 0 100-4 2 2 0 000 4z"
});

function SvgIconVerticalDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "currentColor"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDUgMTYiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAyQzQuNSAzLjEwNDU3IDMuNjA0NTcgNCAyLjUgNEMxLjM5NTQzIDQgMC41IDMuMTA0NTcgMC41IDJDMC41IDAuODk1NDMxIDEuMzk1NDMgMCAyLjUgMEMzLjYwNDU3IDAgNC41IDAuODk1NDMxIDQuNSAyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik00LjUgOEM0LjUgOS4xMDQ1NyAzLjYwNDU3IDEwIDIuNSAxMEMxLjM5NTQzIDEwIDAuNSA5LjEwNDU3IDAuNSA4QzAuNSA2Ljg5NTQzIDEuMzk1NDMgNiAyLjUgNkMzLjYwNDU3IDYgNC41IDYuODk1NDMgNC41IDhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTIuNSAxNkMzLjYwNDU3IDE2IDQuNSAxNS4xMDQ2IDQuNSAxNEM0LjUgMTIuODk1NCAzLjYwNDU3IDEyIDIuNSAxMkMxLjM5NTQzIDEyIDAuNSAxMi44OTU0IDAuNSAxNEMwLjUgMTUuMTA0NiAxLjM5NTQzIDE2IDIuNSAxNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIconVerticalDots as ReactComponent };